import {CircularProgress} from '@mui/material';
import {useWebsiteDetails} from '../../api';
import {LayoutBuilder} from './components/LayoutBuilder';
import {ApiError} from '../../common/ApiError';
import {NotFoundScreen} from '../NotFoundScreen';
import {APIResponseType, WebsiteStructure} from '../../api/models';
import {useContext, useEffect} from 'react';
import {CartContext} from '../../api/context';

export const RetailerWebScreen = ({subDomain}: {subDomain: string}) => {
    const {data, error, isLoading, isSuccess, isError, refetch} = useWebsiteDetails(subDomain);
    const context = useContext(CartContext);

    useEffect(() => {
        if (data) {
            if (data.type === APIResponseType.WebsiteStructure) {
                const websiteData = data.data as WebsiteStructure;
                context?.setWebsiteId(websiteData.id);
            }
        }
    }, [data]);

    if (isLoading) {
        return (
            <div>
                <CircularProgress />
            </div>
        );
    } else if (isError) {
        return <ApiError title={error.name} subtitle={error.message} onButtonClick={refetch} />;
    } else if (isSuccess) {
        if (data.type === APIResponseType.WebsiteStructure) {
            const websiteData = data.data as WebsiteStructure;
            return (
                <div>
                    <LayoutBuilder data={websiteData} />
                </div>
            );
        } else {
            // handle case where something went wrong, show some ui
            return <></>;
        }
    } else {
        return <NotFoundScreen />;
    }
};
